import {Exchange} from '../enums/exchange';
import {Security} from './security';

export interface SecurityKey {
    symbol: string;
    securityExchange: Exchange;
    currency: string;
}

export const SECURITY_KEY_PARTS_SEPARATOR = ':';

export function formatSecurityKey(security: SecurityKey | Security): string {
    return (security as Security).securityKey // Can be not defined in API in old projects.
        || [
            security.symbol || '',
            security.securityExchange || '',
            security.currency || ''
        ].join(SECURITY_KEY_PARTS_SEPARATOR);
}

export function parseSecurityKey(securityKeyStr: string): SecurityKey {
    let [symbol, securityExchange, currency] = securityKeyStr.split(SECURITY_KEY_PARTS_SEPARATOR);

    symbol = symbol || null;
    securityExchange = securityExchange || null;
    currency = currency || null;

    return {symbol, securityExchange: securityExchange as Exchange, currency};
}

export function isSecurityKeysEqual(securityKey: SecurityKey, otherSecurityKey: SecurityKey): boolean {
    return !!securityKey === !!otherSecurityKey
        && (
            !securityKey || (
                securityKey.symbol === otherSecurityKey.symbol
                && securityKey.securityExchange === otherSecurityKey.securityExchange
                && securityKey.currency === otherSecurityKey.currency
            )
        );
}

export function clearSecurityKey<T extends SecurityKey>(security: T): SecurityKey {
    const {symbol, securityExchange, currency} = security;

    return {symbol, securityExchange, currency};
}

export function compareSecurityKeys(securityKey1: SecurityKey, securityKey2: SecurityKey): number {
    return securityKey1.symbol.localeCompare(securityKey2.symbol, undefined, {numeric: true})
        || securityKey1.securityExchange
            .localeCompare(securityKey2.securityExchange, undefined, {numeric: true});
}

export function parseSecurityKeyArr(securityKeyArr: [string, Exchange, string]): SecurityKey {
    const [symbol, securityExchange, currency] = securityKeyArr;

    return {symbol, securityExchange, currency};
}
